import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { UserCheck, FileCheck, DollarSign, Star } from 'lucide-react';

const WhyChooseSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: UserCheck,
      title: t('whyChoose.personalized.title'),
      description: t('whyChoose.personalized.description'),
    },
    {
      icon: FileCheck,
      title: t('whyChoose.hassleFree.title'),
      description: t('whyChoose.hassleFree.description'),
    },
    {
      icon: DollarSign,
      title: t('whyChoose.affordable.title'),
      description: t('whyChoose.affordable.description'),
    },
    {
      icon: Star,
      title: t('whyChoose.proven.title'),
      description: t('whyChoose.proven.description'),
    },
  ];

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t('whyChoose.title')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('whyChoose.subtitle')}
          </p>
        </motion.div>

        {/* ICEF Accreditation Badge */}
        <div className="flex justify-center mb-12 scale-[1.5] origin-center">
          <span id="iasBadge" data-account-id="6983" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group"
              >
                <div className="bg-card rounded-2xl p-8 h-full shadow-card border border-border/50 hover:border-primary/30 hover:shadow-lg transition-all duration-300 text-center">
                  <div className="bg-primary/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6 mx-auto group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-300">
                    <Icon className="h-8 w-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
